export const footerData = [
  {
    id: 'p1',
    title: 'Dịch vụ',
    items: [
      {
        id: 'p1c1',
        name: 'Dịch vụ giao hàng',
        href: '/service/aha-delivery',
        external: false,
      },
      {
        id: 'p1c2',
        name: 'Thuê xe điện',
        href: 'https://thuexedien.ahamove.com/',
        external: true,
      },
      {
        id: 'p1c3',
        name: 'Dịch vụ xe tải',
        href: '/service/aha-truck',
        external: false,
      },
      {
        id: 'p1c4',
        name: 'Dịch vụ doanh nghiệp',
        href: '/service/cooperate',
        external: false,
      },
    ],
  },
  {
    id: 'p2',
    title: 'Công ty',
    items: [
      {
        id: 'p2c1',
        name: 'Về chúng tôi',
        href: '/about-us',
        external: false,
      },
      {
        id: 'p2c2',
        name: 'Tin tức',
        href: '/tin-tuc',
        external: false,
      },
      {
        id: 'p2c3',
        name: 'Tuyển dụng',
        href: '/recruitment',
        external: false,
      },
      // {
      //   id: 'p2c4',
      //   name: 'Chương trình AhaFuture2024',
      //   href: '/internship-program',
      //   external: false,
      // },
    ],
  },
  {
    id: 'p3',
    title: 'Khách hàng',
    items: [
      {
        id: 'p3c1',
        name: 'Khách hàng cá nhân',
        href: '/customer/merchant',
        external: false,
      },
      {
        id: 'p3c2',
        name: 'Khách hàng doanh nghiệp',
        href: '/customer/cooperate',
        external: false,
      },
      {
        id: 'p3c3',
        name: 'Cộng đồng khách hàng',
        href: 'https://www.facebook.com/groups/1913817152225236/',
        external: true,
      },
      {
        id: 'p3c4',
        name: 'Trung tâm hỗ trợ',
        href: '/customer/help-center',
        external: false,
      },
      {
        id: 'p3c5',
        name: 'Tài khoản tích hợp',
        href: '/intergration-account',
        external: false,
      },
    ],
  },
  {
    id: 'p4',
    title: 'Hỗ trợ',
    items: [
      {
        id: 'p4c1',
        name: 'Chính sách và điều khoản',
        href: '/policy',
        external: false,
      },
    ],
  },
  {
    id: 'p5',
    title: 'Tài xế',
    items: [
      {
        id: 'p5c1',
        name: 'Đăng ký tài xế mới',
        href: '/driver',
        external: false,
      },
      {
        id: 'p5c2',
        name: 'Cộng đồng tài xế',
        href: '/blog?category=shippers',
        external: false,
      },
      {
        id: 'p5c3',
        name: 'Cẩm nang tài xế',
        href: '/so-tay-truc-tuyen-danh-cho-doi-tac-ahamove',
        external: false,
      },
      {
        id: 'p5c4',
        name: 'Trung tâm hỗ trợ',
        href: '/driver/help-center',
        external: false,
      },
    ],
  },
  {
    id: 'p6',
    title: 'Đường dẫn nhanh',
    items: [
      {
        id: 'p6c1',
        name: 'Trung tâm hỗ trợ khách hàng',
        href: '/customer/help-center',
        external: false,
      },
      {
        id: 'p6c2',
        name: 'Trung tâm hỗ trợ tài xế',
        href: '/driver/help-center',
        external: false,
      },
      {
        id: 'p6c3',
        name: 'Nền tảng nhà phát triển',
        external: true,
        href: 'https://developers.ahamove.com',
      },
    ],
  },
];

const isDev = process.env.NODE_ENV === 'development';

export const footerDataKinhDoanh = [
  {
    id: 'p1',
    title: 'Kinh nghiệm kinh doanh',
    items: [
      {
        id: 'p1c1',
        name: 'Kinh nghiệm mở cửa hàng',
        href: `${
          isDev ? '/kinhdoanh' : ''
        }/kinh-nghiem-kinh-doanh/kinh-nghiem-mo-cua-hang`,
        external: false,
      },
      {
        id: 'p1c2',
        name: 'Bán hàn online',
        href: `${
          isDev ? '/kinhdoanh' : ''
        }/kinh-nghiem-kinh-doanh/ban-hang-online`,
        external: true,
      },
      {
        id: 'p1c3',
        name: 'Kinh doanh trên Facebook',
        href: `${
          isDev ? '/kinhdoanh' : ''
        }/kinh-nghiem-kinh-doanh/kinh-doanh-tren-facebook`,
        external: false,
      },
      {
        id: 'p1c4',
        name: 'Kinh doanh trên Shopee',
        href: `${
          isDev ? '/kinhdoanh' : ''
        }/kinh-nghiem-kinh-doanh/kinh-doanh-tren-shopee`,
        external: false,
      },
      {
        id: 'p1c5',
        name: 'Kinh doanh trên TikTok Shop',
        href: `${
          isDev ? '/kinhdoanh' : ''
        }/kinh-nghiem-kinh-doanh/kinh-doanh-tren-tiktok-shop`,
        external: true,
      },
      {
        id: 'p1c6',
        name: 'Kinh doanh trên Lazada',
        href: `${
          isDev ? '/kinhdoanh' : ''
        }/kinh-nghiem-kinh-doanh/kinh-doanh-tren-lazada`,
        external: false,
      },
      {
        id: 'p1c7',
        name: 'Kiến thức marketing',
        href: `${
          isDev ? '/kinhdoanh' : ''
        }/kinh-nghiem-kinh-doanh/kien-thuc-marketing`,
        external: false,
      },
    ],
  },
  {
    id: 'p2',
    title: 'Ý tưởng kinh doanh',
  },
  {
    id: 'p3',
    title: 'Nguồn hàng',
    items: [
      {
        id: 'p3c1',
        name: 'Chợ đầu mối',
        href: `${isDev ? '/kinhdoanh' : ''}/nguon-hang/cho-dau-moi`,
        external: false,
      },
      {
        id: 'p3c2',
        name: 'Cách nhập hàng',
        href: `${isDev ? '/kinhdoanh' : ''}/nguon-hang/cach-nhap-hang`,
        external: false,
      },
    ],
  },
  {
    id: 'p4',
    title: 'Kho bãi',
  },
];
